import React from 'react';

const Vue_Certificate = () => {
  return (
    <div>
      <h1>Vue_Certificate Component</h1>
      <p>This is the Vue_Certificate tutorial page.</p>
    </div>
  );
}

export default Vue_Certificate;
